// Import Rails UJS and Turbo for proper form handling
import { Turbo } from '@hotwired/turbo-rails'
import { Application } from '@hotwired/stimulus'
import { registerControllers } from 'stimulus-vite-helpers'

// Bootstrap JS is loaded via the appstack theme bundle — do not import again here

// Start Turbo
Turbo.start()

// Start Stimulus
const application = Application.start()
registerControllers(application, import.meta.glob('../controllers/**/*_controller.js', { eager: true }))

// Simple vanilla JavaScript for folder functionality
document.addEventListener('DOMContentLoaded', function() {
  initializeFolderToggle()
})

// Also run after Turbo navigations
document.addEventListener('turbo:load', function() {
  initializeFolderToggle()
})

function initializeFolderToggle() {
  console.log('Initializing folder toggle functionality...')
  
  // Find all folder toggle elements
  const folderToggles = document.querySelectorAll('.folder-toggle')
  console.log('Found', folderToggles.length, 'folder toggles')
  
  // Remove any existing event listeners first
  folderToggles.forEach(toggle => {
    const newToggle = toggle.cloneNode(true)
    toggle.parentNode.replaceChild(newToggle, toggle)
  })
  
  // Add fresh event listeners
  const freshToggles = document.querySelectorAll('.folder-toggle')
  freshToggles.forEach(toggle => {
    toggle.addEventListener('click', function(event) {
      event.preventDefault()
      event.stopPropagation()
      
      const folderKey = this.dataset.folder
      console.log('Toggling folder:', folderKey)
      
      const subItems = document.querySelector(`[data-folder="${folderKey}"].folder-sub-items`)
      const chevron = document.querySelector(`[data-folder="${folderKey}"].folder-chevron`)
      
      if (subItems && chevron) {
        console.log('Found sub-items and chevron, toggling...')
        
        // Toggle the collapse
        subItems.classList.toggle('show')
        chevron.classList.toggle('expanded')
        
        console.log('Sub-items now has show class:', subItems.classList.contains('show'))
        console.log('Chevron now has expanded class:', chevron.classList.contains('expanded'))
      } else {
        console.log('Could not find sub-items or chevron for folder:', folderKey)
      }
    })
  })
  
  console.log('Folder toggle initialization complete')
}

console.log('Vite ⚡️ Rails with Turbo loaded');

// Import theme files
import '../theme/appstack-4.0/js/app.js';
import '../theme/appstack-4.0/css/app.css';

// Import finder styles from correct location
import './finder.css';

// Import form builder styles
import './form_builder.css';

// Import Tom Select CSS
import 'tom-select/dist/css/tom-select.css';
import './tom_select.css';

// Import compact template card styles (desktop sidebar, mobile bar, template cards)
import './compact_template_card.css';
